import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next");
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(f.email, f.password);
      toast.success(t("login.welcome_back"));
      if (next) nav(next);
      else nav(u.role === "admin" ? "/admin" : "/verkoper");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-[70vh] grid place-items-center px-4 py-16">
      <form onSubmit={submit} className="w-full max-w-md bg-white border border-slate-200 rounded-2xl p-8">
        <h1 className="font-display text-3xl font-extrabold text-[color:var(--wv-obsidian)]">{t("login.title")}</h1>
        <p className="mt-1 text-sm text-slate-500">{t("login.subtitle")}</p>
        <div className="mt-6 space-y-3">
          <div><label className="text-sm font-semibold">{t("login.email")}</label><input className="wv-input mt-1" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="login-email" required /></div>
          <div><label className="text-sm font-semibold">{t("login.password")}</label><input className="wv-input mt-1" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="login-password" required /></div>
        </div>
        <button className="mt-6 w-full wv-btn-primary" disabled={busy} data-testid="login-submit">{busy ? t("login.submitting") : t("login.submit")}</button>
        <p className="mt-4 text-sm text-slate-500 text-center">{t("login.no_account")} <Link to={next ? `/register?next=${encodeURIComponent(next)}` : "/register"} className="text-[color:var(--wv-navy)] font-semibold hover:underline">{t("login.register_link")}</Link></p>
      </form>
    </div>
  );
}
